export interface IFundsSelectorApiClient {
    getFunds(
        searchString: string,
        page: number,
        limit: number,
        sortColumn: string,
        sortDirection: string,
        filter?: {
            fundType?: string[];
            riskRating?: number[];
            mer?: number[];
        },
        options?: { originalHostname?: string; accessToken?: string }
    ): Promise<any[]>;

    getFundsTypes(options?: { originalHostname?: string; accessToken?: string }): Promise<any[]>;
}

export class FundsSelectorApiClient implements IFundsSelectorApiClient {
    baseUrl: string;
    constructor(baseUrl: string = '') {
        this.baseUrl = baseUrl;
    }

    private getHeaders(
        h: {
            [key: string]: string;
        },
        options?: { accessToken?: string }
    ) {
        const headers: {
            [key: string]: string;
        } = {};

        if (typeof options?.accessToken === 'string' && options.accessToken.length > 0) {
            headers.Authorization = `bearer ${options.accessToken}`;
        }

        return { ...headers, ...h };
    }

    async getFunds(
        searchString: string,
        page: number,
        limit: number,
        sortColumn: string,
        sortDirection: string,
        filter?: {
            fundType?: string[];
            riskRating?: number[];
            mer?: number[];
        },
        options?: { originalHostname?: string; accessToken?: string }
    ) {
        const url = `${this.baseUrl || ''}/api/admin/fundsSelector/funds/mdm`;

        const res = await fetch(url, {
            method: 'POST',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
            body: JSON.stringify({
                searchString,
                page,
                limit,
                sortColumn,
                sortDirection,
                filter,
            }),
        });

        return await res.json();
    }

    async getFundsTypes(options?: { originalHostname?: string; accessToken?: string }) {
        const url = `${this.baseUrl || ''}/api/admin/fundsSelector/fundTypes/mdm`;

        const res = await fetch(url, {
            method: 'GET',
            headers: this.getHeaders(
                {
                    'Content-Type': 'application/json',
                },
                options
            ),
        });

        return await res.json();
    }
}
